export default "__VITE_ASSET__CCxNVi6A__"